// @TODO: Stub file, needs functionality added

import type { ReactElement } from 'react'

import type { TabSectionProps } from './types'

export function TabSection(props: TabSectionProps): ReactElement {
  const { children, ...rest } = props

  console.info('TabSection props:', rest)

  return <div>TabSection - PLACEHOLDER</div>
}
